var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  exports = function () {
    var assign = Object.assign,
        obj;
    if (typeof assign !== "function") return false;
    obj = {
      foo: "raz"
    };
    assign(obj, {
      bar: "dwa"
    }, {
      trzy: "trzy"
    });
    return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
  };

  return exports;
}